import { useState } from "react";
import "./datatable.css";
import { DataGrid } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import CenterModal from "../modals/CenterModal";
import DeleteItemModal from "../modals/DeleteItemModal";
import { useSelector } from "react-redux";

const Datatable = ({
  title,
  data,
  actionColumn,
  showCheckBox,
  extraClass,
  bulkDelete,
  initialStore,
  url,
  urlText,
}) => {
  const [idArray, setIdArray] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const { activeStore } = useSelector((state) => state?.listStores);

  const handleBulkDelete = () => {
    setOpenModal(!openModal);
  };
  const deleteAction = () => {
    idArray.forEach((id) => {
      bulkDelete(id);
    });
    setOpenModal(!openModal);
  };
  return (
    <div className={`datatable ${extraClass} overflow-y-scroll`}>
      <div className="mb-[10px] flex items-center text-gray-500 gap-[1rem] justify-between md:justify-start flex-wrap w-[100%] px-2 md:px-8 text-[20px] font-bold md:text-24px">
        {activeStore ? activeStore.brand_name : initialStore.brand_name}
        <div className="flex flex-row justify-between w-[100%] items-center">
          <p className="text-[16px] md:text-xl font-medium">{title}</p>
          {idArray.length > 0 && (
            <button
              onClick={handleBulkDelete}
              className="ml-2 text-[16px] md:text-[20px] text-red-500 p-2 bg-transparent border border-red-500 rounded"
            >
              Bulk Delete
            </button>
          )}

{url ? (
          <Link to={url} className="link text-green-500 p-[5px] cursor-pointer rounded-[4px] text-[14px] md:text-[16px] font-medium border border-green-500">
            {urlText}
          </Link>
        ) : (
          <div></div>
        )}
        </div>
        
      </div>
      <DataGrid
        aria-label="simple table"
        className="datagrid"
        rows={data}
        getRowId={(row) => row.id}
        columns={actionColumn}
        pageSize={9}
        rowsPerPageOptions={[9]}
        checkboxSelection={showCheckBox}
        onSelectionModelChange={(data) => {
          setIdArray(data);
        }}
      />
      {openModal && (
        <CenterModal modalHandler={handleBulkDelete}>
          <DeleteItemModal
            action={deleteAction}
            modalHandler={handleBulkDelete}
          />
        </CenterModal>
      )}
    </div>
  );
};

export default Datatable;
